import { connect } from 'react-redux';
import IndicatorsDashbordOrg from '../../components/dashboard/indicatorsDashbord/Org/IndicatorsDashbordOrg';

const mapStateToProps = () => ({
});

const mapDispatchToProps = () => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(IndicatorsDashbordOrg);
